import { render } from "./SurgeryEdit.vue?vue&type=template&id=7258e4d8&scoped=true"
import script from "./SurgeryEdit.vue?vue&type=script&lang=js"
export * from "./SurgeryEdit.vue?vue&type=script&lang=js"

import "./SurgeryEdit.vue?vue&type=style&index=0&id=7258e4d8&scoped=true&lang=css"

import exportComponent from "C:\\laragon\\www\\dynalist-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7258e4d8"]])

export default __exports__